export default {
    positionStackedChart: {
        forecastBaseline: 'Forecast baseline',
        thisContract: 'This contract',
        otherFutures: 'Other futures',
        finalPosition: 'Final position',
        ariaLabel:
            'Stacked position chart: forecast baseline, this contract, other futures, and final position line',
        tableBucket: 'Bucket',
        tableForecast: 'Forecast',
        tableFinal: 'Final',
    },
}
